import React from 'react';
import { FormattedMessage } from '@kyruus/intl';
import { ListItem } from '@biome-design-system/ui/ListItem';
import { ListItemText } from '@biome-design-system/ui/ListItemText';

import { type Log, type SearchLink, type GetUpdatedSearch } from 'Src/types';
import { searchCategoryDisplayDescriptor } from '../utils';
import { SuggestionLink } from './SuggestionLink';
import { messages } from './messages';

interface SearchSuggestionsProps {
  suggestions: SearchLink[];
  getUpdatedSearch: GetUpdatedSearch;
  log: Log;
}

export const SearchSuggestions = ({
  suggestions,
  getUpdatedSearch,
  log
}: SearchSuggestionsProps) => (
  <>
    {suggestions.map((suggestion: SearchLink, index: number) => {
      const suggestionLink = (
        <SuggestionLink
          suggestion={suggestion}
          getUpdatedSearch={getUpdatedSearch}
          log={log}
        />
      );
      const categoryDescriptor = searchCategoryDisplayDescriptor(
        suggestion.display_search_type
      );

      return (
        <ListItem key={index} disableGutters={true} sx={{ py: 0.5 }}>
          <ListItemText primaryTypographyProps={{ variant: 'body1' }}>
            <FormattedMessage
              {...messages.didYouMeanMessage}
              values={{
                suggestion: suggestionLink,
                categoryName: <FormattedMessage {...categoryDescriptor} />
              }}
            />
          </ListItemText>
        </ListItem>
      );
    })}
  </>
);
